<template>
  <div class="header">
      <div class="videoContainer hide-for-small-only">
          <img class="logo" src="../assets/logo.png"/>
          <div :class="mobileMenuShown ? 'mobile-nav maxheight' : 'mobile-nav'">
            <div class="menu-icon" @click="mobileMenuShown = !mobileMenuShown">
              <div :class="mobileMenuShown ? 'border pos' : 'border'"/>
              <div :class="mobileMenuShown ? 'border neg' : 'border'"/>
            </div>
            <ul>
              <li><a href="#">Home</a></li>
              <li><a @click="moveTo('about')">About</a></li>
              <li><a @click="moveTo('facts')">Facts</a></li>
              <li><a @click="moveTo('prev')">Preview</a></li>
              <li><a @click="moveTo('contact')">Contact</a></li>
            </ul>
          </div>
          <div class="nav">
            <ul>
              <li><a>Home</a></li>
              <li><a @click="moveTo('about')">About</a></li>
              <li><a @click="moveTo('facts')">Facts</a></li>
              <li><a @click="moveTo('prev')">Preview</a></li>
              <li><a @click="moveTo('contact')">Contact</a></li>
            </ul>
          </div>
          <div :class="videoStarted ? 'name fadeout' : 'name'">
            <h1><span class="wizy">WIZ<span class="wizy-y">y</span></span> Travel Kit</h1>
            <h2>World's first all-in-one, global payment & travel kit</h2>
            <div class="header-btns">
              <a href="#download" id="getit">Get it Now</a>
              <a id="play" @click="startVideo">Play Video ▶</a>
            </div>
          </div>
          <div :class="videoStarted ? 'overlay fadeout' : 'overlay visible'"></div>
          <div class="coverImg">
            <div v-if="bufferingDetected" id="spinner" class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            <img :class="videoStarted ? 'mockup-size rotate' : 'mockup-size rotated'" src="../assets/prevideomockup.png"/>
            <div :class="videoVisible ? 'video-wrapper' : 'video-wrapper hidden'">
              <video controls="true" preload="auto" id="videowizy" class="video mockup-size" muted>
                  <source src="../assets/video.mp4" type="video/mp4">
              </video>
              <p :class="videoDescClass">{{actualVideoDescription}}</p>
              <img src="../assets/mockupframe.png" class="mockupframe mockup-size">
            </div>
          </div>
          <div class="cut"></div>
      </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    mobileMenuShown: false
  },
  data(){
    return{
        videoStarted: false,
        videoVisible: false,
        actualVideoDescription: '',
        videoDescription: [
          'Enable your automatic tax refund with one simple swipe during registration!',
          'WIZY TravelKit lets you explore cities swift & easy by simply swiping the sights.',
          'Just tap to take a closer look and check more photos, directions and reviews.',
          'Hungry? No problem, just tap the foods icon and get a list of the best restaurants the city has to offer.',
          'With WIZY TravelKit you can leave your purse at rest. All your bonus programs are neatly organized in the ‚Pocket‘ ',
          'And so are your invoices, so you can later easily submit and review them at any time.',
          'No cash needed - just enjoy paying with WIZY TravelKit.',
          'You can pay using various popular Payment Sources.',
          'All your expenses are tagged and listed inside the "Pocket".',
          'Ready to pay? Present your smartphone to the NFC terminal and click the "Pay" button.'
        ],
        videoDescClass: 'video-description desc-fin',
        fadeCounter: 0,
        bufferingDetected: false,
        checkIntervall: 50.0,
        lastVideoPos: 0,
        curVideoPos: 0
    }
  },
  methods:{
    startVideo(){
      this.videoStarted = true
      window.setTimeout(() => {
        this.videoVisible = true;
        var video = document.getElementById('videowizy');
        video.addEventListener('ended',this.stopVideo,false);
        video.controls=false;
        video.play();   
        video.ontimeupdate = () => this.videoTimeUpdate(video)
        
      },2000)

      //Buffer Detection
      window.setInterval(() => {
        var video = document.getElementById('videowizy');
        this.curVideoPos = video.currentTime
        // checking offset should be at most the check interval
        // but allow for some margin
        var offset = (this.checkIntervall - 10) / 1000

        // if no buffering is currently detected,
        // and the position does not seem to increase
        // and the player isn't manually paused...
        if (!this.bufferingDetected && this.curVideoPos < (this.lastVideoPos + offset) && !video.paused) {
            console.log("buffering")
            this.bufferingDetected = true
        }
        // if we were buffering but the player has advanced,
        // then there is no buffering
        if (this.bufferingDetected && this.curVideoPos > (this.lastVideoPos + offset) && !video.paused) {
            console.log("not buffering anymore")
            this.bufferingDetected = false
        }
        this.lastVideoPos = this.curVideoPos
      },this.checkIntervall)
    },
    stopVideo(){
      this.videoVisible = false
      this.videoStarted = false
    },
    moveTo(id){
      var ele = document.getElementById(id);
      window.scrollTo(0,ele.offsetTop);
    },
    videoTimeUpdate(video){
      if(video.currentTime >= 1 && video.currentTime < 17){
        this.actualVideoDescription = this.videoDescription[0];
      }
      else if(video.currentTime >= 17 && video.currentTime < 20){
        this.simulateFade(1);
      }
      else if(video.currentTime >= 20 && video.currentTime < 26){
        this.simulateFade(2);
      }
      else if(video.currentTime >= 26 && video.currentTime < 31){
        this.simulateFade(3);
      }
      else if(video.currentTime >= 31 && video.currentTime < 35){
        this.simulateFade(4);
      }
      else if(video.currentTime >= 35 && video.currentTime < 56){//pocket
        this.simulateFade(5);
      }
      else if(video.currentTime >= 56 && video.currentTime < 61){
        this.simulateFade(6);
      }
      else if(video.currentTime >= 61 && video.currentTime < 65){
        this.simulateFade(7);
      }
      else if(video.currentTime >= 65 && video.currentTime < 70){
        this.simulateFade(8);
      }
      else if(video.currentTime >= 70 && video.currentTime < 75){
        this.simulateFade(9);
      }
    },
    simulateFade(c){
      if(c != this.fadeCounter){
        this.fadeCounter = c;
        this.videoDescClass = 'video-description desc-fout'
        window.setTimeout(() => {
          this.actualVideoDescription = this.videoDescription[this.fadeCounter];
          this.videoDescClass = 'video-description desc-fin'
        },200)
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";

.desc-fin{
  transition: opacity 0.2s ease;
  opacity: 1;
}
.desc-fout{

    transition: opacity 0.2s ease;
    opacity: 0;
}

.fadeout{
  transition: opacity 2s ease-out;
  opacity: 0;
}
.hidden{
  display: none;
}
.visible{
  transition: opacity 2s ease-out;
  opacity: 1;
}

.mockup-size{
  width: 50%;
  @media(min-width: 780px){
    width: 20%;
  }
  @media(min-width: 2000px){
    width: 12%;
  }
}

.rotate{
  position: absolute;
  transition: all 2s ease;
  transform: rotate(0) translateX(-50%);
  top: 5%;
}
.rotated{
  position: absolute;
  transition: all 2s ease;
  transform: rotate(45deg) translateX(-50%);
  top: 20%;
}

.video-wrapper{
  width: 100%;
  .video{
    position: absolute;
    transform: translateX(-50%);
    top: 7%;
    &.mockup-size{
      width: 17.5%;
      @media(min-width: 2000px){
        width: 10.5%;
      }
    }
  }
  .mockupframe{
    position: absolute;
    top: 5%;
    transform: translateX(-50%);
  }
  .video-description{
    color: white;
    font-size: 1.8rem;
    width: 25%;
    line-height: 2rem;
    font-size: bold;
    position: absolute;
    top: 40%;
    right: 10%;
    transform: translateY(-50%);
  }
}

.cut{
  width: 150%;
  background-color: white;
  height: 160px;
  position: absolute;
  bottom: -10%;
  @media(min-width: 2000px){
    height: 200px;
    bottom: -5%;
  }
  transform: rotate(-3deg) translateX(-10%);
  z-index: 3;
}

.videoContainer {
    position: relative;
    width: 100%;
    height: 600px;
    @media(min-width: 780px){
      height: 800px;
    }
    @media(min-width: 2000px){
      height: 1000px;
    }
    background-attachment: scroll;
    overflow: hidden;
    .logo{
      display: inherit;
      width: 35px;
      position: absolute;
      z-index: 3;
      top: 1%;
      right: 1%;
      filter: brightness(0) invert(1);
      @media(min-width: 780px){
        top: 1%;
        left: 1%;
      }
    }
    .mobile-nav{
      transition: all 0.3s ease;
      transition-property: max-height, background-color, color;
      max-height: calc(2% + 30px);
      position:absolute;
      z-index: 4;
      color: white;
      font-size: 1.2rem;
      @media(min-width: 780px){
        padding-left: 3%;
      }
      width: 100%;
      overflow: hidden;
      .menu-icon {
        font-size: 2em;
        display: block;
        padding-top: 10px;
        cursor: pointer;
        transition: transform .2s ease;
        .border{
          height: 1px;
          padding: 5px;
          transition: all 0.2s ease;
          transition-property: width, border-color, transform;
          width: 10px;
          transform: rotate(0deg) translateX(10px);
          border-top: 1px solid white;
          border-color: white;
          &.pos{
            transition: all 0.2s ease;
            transition-property: width, border-color, transform;
            width: 20px;
            transform: rotate(45deg) translate(5px,5px);
            border-color: black;
          }
          &.neg{
            transition: all 0.2s ease;
            transition-property: width, border-color, transform;
            width: 20px;
            transform: rotate(-45deg) translate(9px,2px);
            border-color: black;
          }
        }
        &:hover{
          cursor: pointer;
        }
      }
      ul{
        padding-bottom: 5%;
        li{
          padding-top: 5%;
          padding-bottom: 2%;
          margin-left: 5%;
          a{
              text-decoration: none;
              color: black;
          }
         }
      }
      @media(min-width: 780px){
        display: none;
      }
      &.maxheight{
        transition: all 0.5s ease;
        transition-property: max-height, background-color, color;
        max-height: 500px;
        background-color: white;
        color: black;
      }
    }
    .nav{
      display: none;
      @media(min-width: 780px){
        display: inherit;
        position: absolute;
        z-index: 3;
        width: 100%;
        color: white;
        ul{
          width: 100%;
          text-align: center;
          @media(min-width: 780px){
            text-align: right;
          }
          li{
            display: inline-block;
            font-size: 1.2rem;
            padding: 2%;
            @media(min-width: 780px){
              padding: 1% 3% 0 0;
              font-size: 1rem;
            }
            a{
              text-decoration: none;
              color: white;
            }
            &:hover{
              cursor: pointer;
            }
          }
        }
      }
    }
    .coverImg{
      background-image: url("../assets/headerbackground.jpg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 1;
      text-align: center;
    }
    .overlay{
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 2;
      background: rgb(54,209,220);
      background: linear-gradient(122deg, rgba(54,209,220,0.95) 20%, rgba(91,134,229,0.95) 95%);
    }
    .name{
      position: absolute;
      color: white;
      width: 100%;
      z-index: 3;
      top: 15%;
      @media(min-width: 780px){
        top: 30%;
      }
      text-align: center;
      h1{
        font-size: 3.5rem;
        font-weight: bold;
        .wizy{
          font-family: 'Ubuntu Condensed', sans-serif;
          .wizy-y{
            font-weight: 500;
            font-size: 4.75rem;
          }
        }
      }
      h2{
        padding: 5% 0 15% 0;
        @media(min-width: 780px){
          padding: 2% 0 5% 0;
        }
        font-size: 1.3rem;
      }
      .header-btns{
        a{
          transition: all .1s ease;
          transition-property: color, background-color;
          color: white;
          padding: 2%;
          @media(min-width: 780px){
            padding: 1%;
          }
          margin: 0% 2% 0% 2%;
          text-decoration: none;
          font-size: 1.3rem;
          font-weight: bold;
          border: 2px solid white;
          border-radius: 1000px;
          &:hover{
            transition: all .1s ease;
            transition-property: color, background-color;
            background-color: white;
            color: rgb(100,161,211);
            cursor: pointer;
          }
        }
        #play{
          display: none;
          @media(min-width: 780px){
            display: initial;
          }
        }
      }
    }
}

.lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  position: absolute;
  top: 30%;
  left: 50%;
  z-index: 50;
  transform: translateX(-50%);
  &.hidden{
    display: none;
  }
}

.lds-spinner div {
  transform-origin: 32px 32px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 29px;
  width: 5px;
  height: 14px;
  border-radius: 20%;
  background: lightgrey;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}


</style>
